

import { createSlice } from "@reduxjs/toolkit";

export const couponSlice = createSlice({
  name: "coupon",
  initialState: {
    coupons: [], // Initialize as an empty array
    edit_coupon_id: null,
    editingCoupon: null, //Add new state to hold the editing coupon
    loading: false,
    error: null,
  },
  reducers: {
    setLoading: (state) => {
      state.loading = true;
      state.error = null; 
    },
    setCoupons: (state, action) => {
      state.loading = false;
      state.error = null;
      state.coupons = action.payload; // Update the coupons state
    },
    setError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addCoupon: (state, action) => {
      state.coupons.push(action.payload);
    },
    setEditingCouponId: (state, action) => {
      state.edit_coupon_id = action.payload;
    },
    setEditingCoupon: (state, action) => {
      const couponId = action.payload;
      const couponToEdit = state.coupons.find((coupon) => coupon.id === couponId);
      if (couponToEdit) {
        state.editingCoupon = couponToEdit;
      }
    },
    updateCoupon: (state, action) => {
      const index = state.coupons.findIndex(
        (coupon) => coupon.id === action.payload.id
      );
      if (index !== -1) {
        state.coupons[index] = action.payload;
      }
      state.edit_coupon_id = null;
    },
    deleteCoupon: (state, action) => {
      state.coupons = state.coupons.filter(
        (coupon) => coupon.id !== action.payload
      );
    },
  },
});

export const {
  setLoading,
  setCoupons,
  addCoupon,
  setEditingCouponId,
  updateCoupon,
  deleteCoupon,
  setError,
  setEditingCoupon
} = couponSlice.actions;

export default couponSlice.reducer;

